// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"_93444fe79c--suggestion--Xnbo6"};